// extracted by mini-css-extract-plugin
export var actionText = "_lg-4";
export var container = "_lg-0";
export var leftSection = "_lg-1";
export var rightSection = "_lg-2";
export var settingsButton = "_lg-6";
export var settingsIcon = "_lg-7";
export var shortcut = "_lg-5";
export var shortcutGroup = "_lg-3";